export const TERMS_AND_CONDITIONS_URL =
  "https://www.cigna.com/legal/compliance/terms-of-use";
export const PRIVACY_POLICY_URL = "https://www.cigna.com/legal/members";
export const CIGNA_URL = "https://www.cigna.com";
